import React from "react";
import moment from "moment";
import './bookingDetails.css'

const BookingDetails = ({
    bookingDetails,
    onClose,
}) => {

    if (!bookingDetails) return null;

    const {
        userData,
        eventData,
        transactionData,
        bookedUsers,
        eventAttendDetails,
    } = bookingDetails;

    const getStatusColor = (status) => {

        switch (status) {

            case "Success":
            case "Booked":
            case "Confirmed":
                return "#2ECC71";

            case "Pending":
                return "#F1C40F";

            case "Cancelled":
            case "Failed":
                return "#E74C3C";

            default:
                return "#FFFFFF";
        }
    };

    return (

        <div
            style={{
                position: "fixed",
                inset: 0,
                background:
                    "rgba(0,0,0,0.75)",
                backdropFilter: "blur(10px)",
                zIndex: 99999,
                overflowY: "auto",
                padding: "30px 20px",
            }}
        >

            <div
                style={{
                    width: "100%",
                    maxWidth: "1250px",
                    margin: "0 auto",
                    background:
                        "linear-gradient(180deg,#001530,#000C1F)",
                    borderRadius: "28px",
                    overflow: "hidden",
                    border:
                        "1px solid rgba(255,255,255,0.08)",
                    boxShadow:
                        "0px 10px 40px rgba(0,0,0,0.5)",
                }}
            >

                {/* ================================================= */}
                {/* EVENT BANNER */}
                {/* ================================================= */}

                <div
                    style={{
                        position: "relative",
                        height: "360px",
                    }}
                >

                    <img
                        src={
                            eventData?.eventPosterImages?.[0]
                            || eventData?.eventImages?.[0]
                        }
                        alt=""
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                        }}
                    />

                    {/* OVERLAY */}

                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(180deg,rgba(0,0,0,0.1),rgba(0,12,31,0.95))",
                        }}
                    />

                    {/* CLOSE BUTTON */}

                    <div
                        onClick={onClose}
                        style={{
                            position: "absolute",
                            top: "25px",
                            right: "25px",
                            width: "44px",
                            height: "44px",
                            borderRadius: "50%",
                            background:
                                "rgba(255,255,255,0.15)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            color: "#FFFFFF",
                            fontSize: "18px",
                            fontWeight: "700",
                            backdropFilter: "blur(8px)",
                        }}
                    >
                        ✕
                    </div>

                    {/* EVENT CONTENT */}

                    <div
                        style={{
                            position: "absolute",
                            bottom: "30px",
                            left: "30px",
                            right: "30px",
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                justifyContent:
                                    "space-between",
                                alignItems: "flex-end",
                                gap: "20px",
                                flexWrap: "wrap",
                            }}
                        >

                            <div>

                                <div
                                    style={{
                                        fontSize: "38px",
                                        fontWeight: "800",
                                        color: "#FFFFFF",
                                    }}
                                >
                                    {eventData?.eventName}
                                </div>

                                <div
                                    style={{
                                        color:
                                            "rgba(255,255,255,0.7)",
                                        marginTop: "10px",
                                        maxWidth: "700px",
                                        lineHeight: "26px",
                                        fontSize: "15px",
                                    }}
                                >
                                    {
                                        eventData?.eventDescription
                                    }
                                </div>

                            </div>

                            {/* STATUS */}

                            <div
                                style={{
                                    display: "flex",
                                    gap: "12px",
                                    flexWrap: "wrap",
                                }}
                            >

                                <StatusCard
                                    title="Payment"
                                    value={
                                        bookingDetails?.paymentStatus
                                    }
                                    color={getStatusColor(
                                        bookingDetails?.paymentStatus
                                    )}
                                />

                                <StatusCard
                                    title="Booking"
                                    value={
                                        bookingDetails?.bookingStatus
                                    }
                                    color={getStatusColor(
                                        bookingDetails?.bookingStatus
                                    )}
                                />

                            </div>

                        </div>

                    </div>

                </div>

                {/* ================================================= */}
                {/* BODY */}
                {/* ================================================= */}

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "25px",
                        padding: "25px",
                    }}
                >

                    {/* ================================================= */}
                    {/* ROW 1 */}
                    {/* ================================================= */}

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1.3fr 1fr",
                            gap: "25px",
                            alignItems: "stretch",
                        }}
                    >

                        {/* EVENT INFORMATION */}

                        <SectionCard title="Event Information">
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2,1fr)",
                                    gap: "15px"
                                }}
                            >

                                <GridInfo
                                    label="Date"
                                    value={moment(eventData?.eventDate).format("DD MMM YYYY")}
                                />

                                <GridInfo
                                    label="Time"
                                    value={eventData?.eventTime}
                                />

                                <GridInfo
                                    label="Venue"
                                    value={eventData?.venueName}
                                />

                                <GridInfo
                                    label="Category"
                                    value={eventData?.eventCategory}
                                />


                            </div>

                        </SectionCard>

                        {/* BOOKED BY */}

                        <SectionCard title="Booked By">

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "18px",
                                    padding: "18px",
                                    borderRadius: "18px",
                                    background: "rgba(255,255,255,.03)",
                                    border: "1px solid rgba(255,255,255,.08)",
                                    marginBottom: "20px"
                                }}
                            >
                                <img
                                    src={userData?.profileImageURL}
                                    alt=""
                                    style={{
                                        width: "80px",
                                        height: "80px",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        border: "3px solid #635BFF"
                                    }}
                                />

                                <div>
                                    <div
                                        style={{
                                            color: "#fff",
                                            fontSize: "22px",
                                            fontWeight: 700
                                        }}
                                    >
                                        {userData?.name}
                                    </div>

                                    <div
                                        style={{
                                            color: "#8EA4D2",
                                            marginTop: 4
                                        }}
                                    >
                                        @{userData?.userName}
                                    </div>

                                    <div
                                        style={{
                                            display: "inline-block",
                                            marginTop: "8px",
                                            padding: "4px 12px",
                                            borderRadius: "30px",
                                            background: "rgba(99,91,255,.15)",
                                            color: "#8EA4FF",
                                            fontSize: "12px",
                                            fontWeight: 600
                                        }}
                                    >
                                        {userData?.userType}
                                    </div>
                                </div>
                            </div>

                            <DetailRow
                                label="Email"
                                value={userData?.email || "-"}
                            />

                            <DetailRow
                                label="Mobile"
                                value={`+${userData?.countryCode || ""} ${userData?.mobile || ""}`}
                            />

                            <DetailRow
                                label="User Type"
                                value={userData?.userType || "-"}
                            />

                        </SectionCard>

                    </div>

                    {/* ================================================= */}
                    {/* ROW 2 */}
                    {/* ================================================= */}

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1.3fr 1fr",
                            gap: "25px",
                            alignItems: "stretch",
                        }}
                    >

                        {/* BOOKED USERS */}
                        <SectionCard title={`Booked Users (${bookedUsers?.length || 0})`}>
                            <div
                                className="booked-users-scroll"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "12px",
                                    maxHeight: "360px", // approx 4 users
                                    overflowY: "auto",
                                    paddingRight: "6px"
                                }}
                            >
                                {bookedUsers?.map((user, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "15px",
                                            padding: "16px",
                                            borderRadius: "16px",
                                            background:
                                                "linear-gradient(180deg,#102765,#0B1C4D)",
                                            border:
                                                "1px solid rgba(255,255,255,.08)"
                                        }}
                                    >
                                        <img
                                            src={user?.profileImageURL}
                                            alt=""
                                            style={{
                                                width: "55px",
                                                height: "55px",
                                                borderRadius: "50%",
                                                objectFit: "cover"
                                            }}
                                        />

                                        <div>
                                            <div
                                                style={{
                                                    color: "#fff",
                                                    fontWeight: 700,
                                                    fontSize: "18px"
                                                }}
                                            >
                                                {user?.name}
                                            </div>

                                            <div
                                                style={{
                                                    color: "#8EA4D2",
                                                    marginTop: "4px"
                                                }}
                                            >
                                                {user?.email}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </SectionCard>


                        {/* PAYMENT SUMMARY */}

                        <SectionCard title="Payment Summary">

                            <DetailRow
                                label="Ticket Price"
                                value={`₹${bookingDetails?.ticketPrice || 0}`}
                            />

                            <DetailRow
                                label="Quantity"
                                value={bookingDetails?.quantity || 0}
                            />

                            <div
                                style={{
                                    background: "rgba(255,255,255,.03)",
                                    borderRadius: "16px",
                                    padding: "18px",
                                    marginBottom: "20px"
                                }}
                            />

                            <DetailRow
                                label="Sub Total"
                                value={`₹${bookingDetails?.subTotal || 0}`}
                            />

                            <DetailRow
                                label="Tax Amount"
                                value={`₹${bookingDetails?.taxAmount || 0}`}
                            />

                            <DetailRow
                                label="Platform Fee"
                                value={`₹${bookingDetails?.platformFeeAmount || 0}`}
                            />

                            {!!bookingDetails?.refundAmount && (
                                <DetailRow
                                    label="Refund"
                                    value={`- ₹${bookingDetails?.refundAmount}`}
                                    valueStyle={{
                                        color: "#FFA94D",
                                        fontWeight: "600",
                                    }}
                                />
                            )}

                            <div
                                style={{
                                    height: "1px",
                                    background:
                                        "linear-gradient(90deg, transparent, rgba(255,255,255,.2), transparent)",
                                    margin: "20px 0",
                                }}
                            />

                            <div
                                style={{
                                    marginTop: "20px",
                                    padding: "18px",
                                    borderRadius: "18px",
                                    background:
                                        "linear-gradient(135deg,#00B894,#00E6A7)",
                                    color: "#fff"
                                }}
                            >
                                <div>Total Amount</div>

                                <div
                                    style={{
                                        fontSize: "32px",
                                        fontWeight: 800,
                                        marginTop: "5px"
                                    }}
                                >
                                    ₹{bookingDetails?.totalAmount}
                                </div>
                            </div>

                        </SectionCard>

                    </div>

                    {/* ================================================= */}
                    {/* ROW 3 */}
                    {/* ================================================= */}

                    {bookingDetails?.bookingType === "Third-Party" && (
                        <SectionCard title="Third Party Ticket Details">

                            <DetailRow
                                label="Reference Ticket ID"
                                value={
                                    eventAttendDetails?.referenceTicketId || "-"
                                }
                            />

                            {eventAttendDetails?.referenceScreenshot && (
                                <div
                                    style={{
                                        marginTop: "20px",
                                        padding: "12px",
                                        borderRadius: "20px",
                                        background: "rgba(255,255,255,.03)",
                                        border: "1px solid rgba(255,255,255,.08)"
                                    }}
                                >
                                    <img
                                        src={eventAttendDetails?.referenceScreenshot}
                                        alt=""
                                        style={{
                                            width: "100%",
                                            height: "350px",
                                            objectFit: "cover",
                                            borderRadius: "14px"
                                        }}
                                    />
                                </div>
                            )}

                        </SectionCard>
                    )}

                </div>

            </div>

        </div>
    );
};

const SectionCard = ({ title, children }) => (
    <div
        style={{
            background:
                "linear-gradient(180deg, rgba(8,25,72,0.95) 0%, rgba(4,17,52,0.98) 100%)",
            border: "1px solid rgba(99,91,255,.25)",
            borderRadius: "20px",
            padding: "22px",
            backdropFilter: "blur(20px)",
            boxShadow:
                "0 8px 25px rgba(0,0,0,.25), inset 0 1px 0 rgba(255,255,255,.04)",
            position: "relative",
            overflow: "hidden",
            minHeight: "fit-content",
            maxHeight: "380px"
        }}
    >
        <div
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "4px",
                background:
                    "linear-gradient(90deg,#635BFF,#00D4FF)"
            }}
        />

        <h3
            style={{
                color: "#fff",
                fontSize: "18px",
                fontWeight: 700,
                marginBottom: "20px"
            }}
        >
            {title}
        </h3>

        {children}
    </div>
);

const GridInfo = ({
    label,
    value,
}) => {

    return (

        <div
            style={{
                background:
                    "rgba(255,255,255,0.03)",
                padding: "16px",
                borderRadius: "14px",
            }}
        >

            <div
                style={{
                    color:
                        "rgba(255,255,255,0.5)",
                    fontSize: "13px",
                }}
            >
                {label}
            </div>

            <div
                style={{
                    color: "#FFFFFF",
                    marginTop: "8px",
                    fontWeight: "600",
                    lineHeight: "22px",
                }}
            >
                {value}
            </div>

        </div>
    );
};

const DetailRow = ({
    label,
    value,
    valueStyle = {},
}) => {

    return (

        <div
            style={{
                display: "flex",
                justifyContent:
                    "space-between",
                gap: "20px",
                marginBottom: "16px",
            }}
        >

            <div
                style={{
                    color:
                        "rgba(255,255,255,0.6)",
                    minWidth: "120px",
                }}
            >
                {label}
            </div>

            <div
                style={{
                    color: "#FFFFFF",
                    fontWeight: "600",
                    textAlign: "right",
                    ...valueStyle,
                }}
            >
                {value}
            </div>

        </div>
    );
};

const StatusCard = ({
    title,
    value,
    color,
}) => {

    return (

        <div
            style={{
                background:
                    "rgba(255,255,255,0.12)",
                padding: "14px 18px",
                borderRadius: "16px",
                minWidth: "130px",
                backdropFilter: "blur(8px)",
            }}
        >

            <div
                style={{
                    color:
                        "rgba(255,255,255,0.6)",
                    fontSize: "12px",
                }}
            >
                {title}
            </div>

            <div
                style={{
                    marginTop: "6px",
                    color: color,
                    fontWeight: "700",
                    fontSize: "16px",
                }}
            >
                {value}
            </div>

        </div>
    );
};

export default BookingDetails;